// 2.5 — the retryable error bubble.
//
// A failed or timed-out turn resolves here instead of to a reply. The student's
// own message is untouched; Try again removes this bubble and re-runs the
// identical text. The button is an ordinary focusable control so the retry is
// reachable by keyboard, and the bubble announces through the message log's
// existing live region.

import styles from './ConversationalForms.module.css';
import { useConversationalForms } from './FormsContext';
import { AlertIcon } from './icons';

type TurnErrorProps = {
    /** Index of this message in the conversation — what retry removes. */
    index: number;
    content: string;
    retryText?: string;
};

const TurnError = ({ index, content, retryText }: TurnErrorProps) => {
    const { retryTurn, state } = useConversationalForms();

    return (
        <div data-testid="cf-turn-error">
            <p className={styles.errorBubble}>
                <AlertIcon />
                <span>{content}</span>
            </p>
            {retryText && (
                <button
                    type="button"
                    className={styles.retry}
                    onClick={() => retryTurn(index, retryText)}
                    // A retry queued behind an in-flight turn would be confusing;
                    // the composer stays open either way, so nothing is blocked.
                    disabled={state.thinking}
                >
                    Try again
                </button>
            )}
        </div>
    );
};

export default TurnError;
